import React from 'react';
import PropTypes from 'prop-types';
import { FindemApplicationContainer } from './FindemApplicationContainer';

export const FindemApplicationCalibration = ({ isLoading, error }) => (
  <FindemApplicationContainer isLoading={isLoading} error={error} title="Calibration Agent" view="calibration" />
);

FindemApplicationCalibration.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

FindemApplicationCalibration.defaultProps = {
  error: null,
};
